// Bridges the Clerk React SDK (hook-only API) so imperative, non-hook code
// (e.g. the class-based App.js logout / session-expiry handlers) can trigger a
// Clerk logout. A small hook-based component registers the SDK's signOut function
// here on mount; callers invoke `clerkLogout()` which no-ops if Clerk is not
// active. This keeps the legacy IdentityServer4 path completely unaffected.
let registeredLogout = null;

export function registerClerkLogout(logoutFn) {
    registeredLogout = logoutFn;
}

// Returns true if a Clerk logout was invoked, false if there was nothing to do
// (legacy path or Clerk not yet initialized).
export function clerkLogout() {
    if (typeof registeredLogout === "function") {
        registeredLogout();
        return true;
    }
    return false;
}
